import React from 'react';
import HorizontalGroup from './HorizontalGroup';
import HorizontalCollapse from './HorizontalCollapse';
import HorizontalItem from './HorizontalItem';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import { useSelector } from 'react-redux';

import routesConfig from '../../../../modules/routesConfig';
import Box from '@material-ui/core/Box';
import { selectEnableFoundry } from 'redux/reducers/admin/instance-settings';

const HorizontalNav = () => {
  const enableFoundry = useSelector(selectEnableFoundry);

  const canRenderItem = (item) => {
    if (item.requireFoundry && !enableFoundry) {
      return false;
    }
    return item.access.indexOf(localStorage.getItem('userRole')) > -1;
  };

  return (
    <List className='navbarNav'>
      {routesConfig.map((item) => (
        <React.Fragment key={item.id}>
          {item.type === 'group' && canRenderItem(item) && (
            <HorizontalGroup item={item} nestedLevel={0} />
          )}

          {item.type === 'collapse' && canRenderItem(item) && (
            <HorizontalCollapse item={item} nestedLevel={0} />
          )}

          {item.type === 'item' && canRenderItem(item) && (
            <HorizontalItem item={item} nestedLevel={0} />
          )}

          {item.type === 'divider' && canRenderItem(item) && (
            <Box my={5} clone>
              <Divider />
            </Box>
          )}
        </React.Fragment>
      ))}
    </List>
  );
};

export default HorizontalNav;
